// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--f70a5";
export var hero__img = "hero-module--hero__img--4a8bf";
export var hero__text = "hero-module--hero__text--211cc";